import { environment } from '@doltech/core/lib/environment/environment';
import { getLandingLinearthinkingUrl } from '@doltech/utils/lib/url';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { Typography } from '../../../../DesignSystemV2/Typography';
import { RowLink } from '../RowLink/RowLink';

const Main = styled.div`
  display: grid;
  gap: 16px;

  .copy-right-text {
    color: ${colorsV2.black100};
    font-style: italic;
  }
  .links-section {
    display: flex;
    flex-wrap: wrap;
    margin: -4px -12px;
    > * {
      margin: 4px 12px;
    }
    color: ${colorsV2.black100};
    a {
      color: ${colorsV2.black100};
    }
  }
`;

const staticLinks = [
  {
    text: 'Liên hệ',
    link: '/lien-he',
    noFollow: true,
    external: true,
  },
  {
    text: 'Giới thiệu',
    link: '/gioi-thieu',
    noFollow: true,
    external: true,
  },
  {
    text: 'Điều khoản',
    link: '/dieu-khoan-su-dung',
    noFollow: true,
    external: true,
  },
  {
    text: 'Bảo mật',
    link: '/chinh-sach-bao-mat',
    noFollow: true,
    external: true,
  },
];

export const DailyLearningFooter = () => {
  const links = React.useMemo(() => {
    return [
      {
        link: `${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/khoa-hoc-ielts`,
        text: 'Khoá học',
        external: false,
      },
      {
        link: getLandingLinearthinkingUrl(),
        text: 'Linearthinking',
        external: false,
      },
      ...staticLinks,
    ];
  }, []);

  return (
    <Main className="daily-learning-footer">
      <div className="copy-right-section">
        <Typography.Text variant="regular/14" className="copy-right-text">
          © {new Date().getFullYear()} DOL English. All rights reserved.
        </Typography.Text>
      </div>

      <div className="links-section">
        {links.map((item, index) => {
          return <RowLink variant="regular/14" key={index} row={item} />;
        })}
      </div>
    </Main>
  );
};
